export default __webpack_public_path__ + "static/nelc-0fc55d7b5784beb61770556aae81ee51.png";